import React, { forwardRef } from 'react';
import { connect } from 'react-redux';
import { NavItem, NavIcon, NavText } from '@trendmicro/react-sidenav';
import { TextField } from '@material-ui/core';
import Select from 'react-select';
import Button from '@material-ui/core/Button';
import InputAdornment from '@material-ui/core/InputAdornment';
import Avatar from '@material-ui/core/Avatar';
import checkIcon from 'assets/images/icon-check-light.svg'
import Chip from '@material-ui/core/Chip';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
// import { TimePicker } from 'material-ui-pickers';
// import TimePicker from 'antd/lib/time-picker';
import DialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton'
import Close from '@material-ui/icons/Close';
import TreeSelect from 'antd/lib/tree-select';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import 'antd/lib/tree-select/style/css';
import config from '../../config';
import { isNotEmpty } from 'util/helpers';
import 'antd/dist/antd.css';
// import { colourOptions, groupedOptions } from '../data';
import {
    get_list_of_specialisation as get_list_of_specialisation_action,
    update_user_info as update_user_info_action,
    fetch_user_countries as fetch_user_countries_action,
    reset_user_update_details
} from 'actions/user';
import { treeData, denominators, categoryLabels } from 'constants/riiParameters'
import IntlMessages from 'util/IntlMessages';

dayjs.extend(utc)

const DEFAULT_AVATAR = 'profile_image.jpg';
const currentYear = dayjs.utc().toDate().getFullYear();
const range = (start, stop, step) => Array.from({ length: (stop - start) / step + 1 }, (_, i) => ({ label: start + (i * step), value: start + (i * step) }));
const years = range(currentYear, currentYear - 100, -1);

const dob_ref = React.createRef(null);

const CustomDateInput = forwardRef(({ value }, ref) => (
    <button
        className="custom-date-input"
        onMouseDown={() => {
            let isOpen = document.querySelector(".react-datepicker-popper");
            dob_ref.current.setOpen(!isOpen);
        }}
        ref={ref}>{value}</button>
));

class UserInfo extends React.Component {

    state = {
        specialisationInput: [],
        riiParameters: ['APN', 'AHI', 'MOV', 'TST'],
        openDialog: false,
        openDialogUser: false,
        showPhoneFlag: 0,
        window_start_time: this.props.user_details.window_start_time,
        window_end_time: this.props.user_details.window_end_time,
        first_name: this.props.user_details.first_name,
        last_name: this.props.user_details.last_name,
        email_id: this.props.user_details.email_id,
        secondary_emails: this.props.user_details.secondary_emails,
        ternary_email: this.props.user_details.ternary_email,
        organisation_name: this.props.user_details.organisation_name,
        country: this.props.user_details.country,
        primary_phone_number: this.props.user_details.primary_phone_number,
        secondary_phone_number: this.props.user_details.secondary_phone_number,
        other_phone_number: this.props.user_details.other_phone_number,
        date_of_birth: dayjs.utc(this.props.user_details.date_of_birth).toDate(),
        profile_image: this.props.user_details.profile_image || DEFAULT_AVATAR,
        profile_image_error: null,
        tmp_uploaded_profile_image: '',
        display_image: this.props.user_details.profile_image ? `${config.api_url}/${config.api_version}/get-avatar/${this.props.user_details.profile_image}` : `${config.api_url}/${config.api_version}/get-avatar/${DEFAULT_AVATAR}`,
        original_changed: false,
        original_image: this.props.user_details.profile_image ? `${config.api_url}/${config.api_version}/get-avatar/${this.props.user_details.profile_image}` : `${config.api_url}/${config.api_version}/get-avatar/${DEFAULT_AVATAR}`,
        default_image: `${config.api_url}/${config.api_version}/get-avatar/${DEFAULT_AVATAR}`,
        uploaded_profile_image: '',
        removed_profile_image: '0',
        gender: "M",
        height: null,
        weight: null,
        bmi: null,
        openStartWindow: false,
        openStopWindow: false,
        // password: this.props.user_details.password ? crypto.createHash("md5").update(this.props.user_details.password, "md5").digest("hex") : "",
    };

    handleClickOpenUser = () => {
        this.props.handleClickAwayEvent();
        this.props.get_list_of_specialisation();
        this.props.fetch_user_countries();
        this.setState({
            openDialogUser: true,
            openDialog: false,
        });
    };
    componentDidUpdate = (prevProps) => {
        // Typical usage (don't forget to compare props):
        if (this.props !== prevProps) {
            this.setState({
                first_name: this.props.user_details.first_name,
                last_name: this.props.user_details.last_name,
                email_id: this.props.user_details.email_id,
                organisation_name: this.props.user_details.organisation_name,
                country: this.props.user_details.country,
                primary_phone_number: this.props.user_details.primary_phone_number,
                secondary_phone_number: this.props.user_details.secondary_phone_number,
                secondary_emails: this.props.user_details.secondary_emails,
                ternary_email: this.props.user_details.ternary_email ?
                    this.props.user_details.ternary_email.includes('null') ? '' :
                        this.props.user_details.ternary_email.includes('null') :
                    '',
                other_phone_number: this.props.user_details.other_phone_number,
                date_of_birth: dayjs.utc(this.props.user_details.date_of_birth).toDate(),
                email_error: null,
                primary_phone_number_error: null,
                secondary_phone_number_error: null,
                other_phone_number_error: null,
                first_name_error: null,
                update_error: null,
                last_name_error: null,
                showPhoneFlag: 0,
                riiParameters: JSON.parse(this.props.user_details.rii_parameters || '["TBT"]'),
                profile_image: this.props.user_details.profile_image || DEFAULT_AVATAR,
                profile_image_error: null,
                // tmp_uploaded_profile_image: '',
                // uploaded_profile_image: '',
                // removed_profile_image: '0',

            });
            const {
                user_details: {
                    specialisation_ids
                },
                user: {
                    specialisation,
                },
                update_profile_error,
                update_user_details,
                updating_user_details,
                password_mismatch,
            } = this.props;
            let selectedSpecialisation = specialisation && specialisation.map((item) => {
                if (specialisation_ids.includes(item.id)) {
                    return {
                        ...item,
                        selected: true
                    }
                }
                else {
                    return item
                }
            });
            if (selectedSpecialisation) {
                this.setState({
                    specialisationInput: selectedSpecialisation
                })
            }
            //To display error in modal for mismatch
            if (!update_user_details && update_profile_error) {
                let message = typeof password_mismatch === "object" ? password_mismatch.message : password_mismatch
                this.setState({
                    update_error: message,
                })
            }
            //To close the modal only if their is a positive use case
            if (update_user_details && !updating_user_details && !update_profile_error) {
                this.props.reset_user_update();
                this.handleCloseUser(1);
            }
            // if (update_user_details === false && update_profile_error === false) {
            //     //this.handleCloseUser();
            // }
        }
    }

    onRiiParametersChange = (values) => {
        const hasDenominator = values.filter(v => denominators[v])
        if (hasDenominator.length > 1) {
            const filteredDenoms = this.state.riiParameters.filter(v => denominators[v]);
            this.setState({
                riiParameters: values.filter(v => !filteredDenoms.includes(v))
            })
        } else if (hasDenominator.length) {
            this.setState({ riiParameters: values })
        }
    }

    handleCloseUser = (saveClicked = 0) => {
        let oldState = { ...this.state };
        let display_img = oldState.display_image;
        let original_img = oldState.original_image

        if (saveClicked === 1 && oldState.tmp_uploaded_profile_image !== '') {
            if (oldState.removed_profile_image === '1') {
                display_img = oldState.default_image;
                original_img = oldState.default_image;
            } else {
                display_img = oldState.tmp_uploaded_profile_image;
                original_img = oldState.tmp_uploaded_profile_image;
            }
        }
        if (saveClicked === 0 || !saveClicked) {
            display_img = oldState.original_image;
        }

        this.setState({
            openDialogUser: false,
            openDialog: false,
            first_name: this.props.user_details.first_name,
            last_name: this.props.user_details.last_name,
            email_id: this.props.user_details.email_id,
            secondary_emails: this.props.user_details.secondary_emails,
            ternary_email: this.props.user_details.ternary_email || '',
            riiParameters: JSON.parse(this.props.user_details.rii_parameters || '["GSD"]'),
            organisation_name: this.props.user_details.organisation_name,
            country: this.props.user_details.country,
            primary_phone_number: this.props.user_details.primary_phone_number,
            secondary_phone_number: this.props.user_details.secondary_phone_number,
            other_phone_number: this.props.user_details.other_phone_number,
            date_of_birth: dayjs.utc(this.props.user_details.date_of_birth).toDate(),
            email_error: null,
            primary_phone_number_error: null,
            secondary_phone_number_error: null,
            other_phone_number_error: null,
            first_name_error: null,
            update_error: null,
            last_name_error: null,
            showPhoneFlag: 0,
            profile_image: this.props.user_details.profile_image || DEFAULT_AVATAR,
            profile_image_error: null,
            tmp_uploaded_profile_image: '',
            original_image: original_img,
            display_image: display_img,
            original_changed: false,
            uploaded_profile_image: '',
            removed_profile_image: '0',

        });
    };

    handleChange = (e) => {
        this.setState({
            country: e.target.value
        })
    }

    handleClickOpen = () => {
        this.setState({
            openDialog: true,
            openDialogUser: false,
            update_error: null,
            secondary_email_error: null,
            ternary_email_error: null,
            tmp_uploaded_profile_image: '',
            uploaded_profile_image: '',
            removed_profile_image: '0'
        });
    };

    validateInputs = () => {
        const formData = this.state;
        this.setState({
            email_error: new RegExp(/[a-z0-9]+(.?_?)[a-z0-9]+@[a-z0-9]+(\.[a-z0-9]+){1,3}/g).test(formData.email_id) ? null : "Please provide a valid email address",
            primary_phone_number_error: formData.primary_phone_number ?
                (new RegExp(/\+?\(?\s?[0-9]-?\s?\)?/g).test(formData.primary_phone_number) && !(new RegExp(/[a-zA-Z$&,;=?@#|'<>.^*%!]/g).test(formData.primary_phone_number)) ? null :
                    "Please provide valid primary phone number") :
                "Please enter primary phone number",
            secondary_phone_number_error: formData.secondary_phone_number ? (new RegExp(/\+?\(?\s?[0-9]-?\s?\)?/g).test(formData.secondary_phone_number) && !(new RegExp(/[a-zA-Z$&,;=?@#|'<>.^*%!]/g).test(formData.secondary_phone_number)) ? null : "Please provide valid secondary phone number") : null,
            other_phone_number_error: formData.other_phone_number ? (new RegExp(/\+?\(?\s?[0-9]-?\s?\)?/g).test(formData.other_phone_number) && !(new RegExp(/[a-zA-Z$&,;=?@#|'<>.^*%!]/g).test(formData.other_phone_number)) ? null : "Please provide valid additional phone number") : null,
            first_name_error: formData.first_name ? (new RegExp(/[0-9$&,;=?@#|'<>.^*%!]/g).test(formData.first_name)) ? "First name accepts characters only" : null : "Please enter First Name",
            last_name_error: formData.last_name ? (new RegExp(/[0-9$&,;=?@#|'<>.^*%!]/g).test(formData.last_name)) ? "Last Name accepts characters only" : null : "Please enter Last Name",
            secondary_email_error: formData.secondary_emails ? (new RegExp(/^([\w+-.%]+@[\w.]+\.[A-Za-z]{2,4})+$/g).test(formData.secondary_emails)) ? null : "Invalid Characters" : null,
            ternary_email_error: formData.ternary_email ? (new RegExp(/^([\w+-.%]+@[\w.]+\.[A-Za-z]{2,4})+$/g).test(formData.ternary_email)) ? null : "Invalid Characters" : null,
            update_error: null,

        });



        if (formData.secondary_emails) {
            if (formData.email_id === formData.secondary_emails) {
                this.setState({
                    secondary_email_error: "Primary email and secondary email cannot be same"
                })
            }
        }

        if (formData.ternary_email) {
            if (formData.email_id === formData.ternary_email) {
                this.setState({
                    ternary_email_error: "Primary email and Tertiary email cannot be same"
                })
            }
            if (formData.ternary_email === formData.secondary_emails) {
                this.setState({
                    ternary_email_error: "Secondary email and Tertiary email cannot be same"
                })
            }
        }


        if ((this.props.user_details.isSecondaryUser) && (!isNotEmpty(formData.secondary_emails))) {

            this.setState({
                secondary_email_error: "Secondary email cannot be empty"
            })

        }

        if ((this.props.user_details.isTernaryUser) && (!isNotEmpty(formData.ternary_email))) {

            this.setState({
                ternary_email_error: "Tertiary email cannot be empty"
            })

        }

        setTimeout(() => {
            if (
                this.state.email_error === null &&
                this.state.primary_phone_number_error === null &&
                this.state.secondary_phone_number_error === null &&
                this.state.other_phone_number_error === null &&
                this.state.first_name_error === null &&
                this.state.last_name_error === null &&
                this.state.secondary_email_error === null &&
                this.state.ternary_email_error === null &&
                this.state.update_error === null) {
                this.handleProfileUpdate(formData)
            }
        }, 1000);
    }

    fileSelectHandler = (event) => {
        let files = event.target.files

        // File format check.
        let filename = files[0].name.toLowerCase();
        if (!filename.match(/\.(jpg|jpeg|png)$/)) {
            this.setState({ profile_image_error: 'Please select valid profile image format (jpg or jpeg or png format allowed)' });
            return false;
        }
        let size = 5000000 // 5000kb = 5 MB
        // File size check.
        if (files[0].size > size) {
            this.setState({ profile_image_error: 'Profile image is too large, please pick a file less that 5 MB' });
            return false;
        }

        if (files[0]) {
            const tmpImg = URL.createObjectURL(files[0])
            this.setState({
                profile_image_error: null,
                uploaded_profile_image: files[0],
                removed_profile_image: '0',
                tmp_uploaded_profile_image: tmpImg,
                display_image: tmpImg,
                original_changed: true
            })
        }
    }

    fileRemoveHandler = () => {
        this.setState({
            profile_image_error: null,
            removed_profile_image: '1',
            uploaded_profile_image: '',
            tmp_uploaded_profile_image: '',
            display_image: this.state.default_image,
            profile_image: DEFAULT_AVATAR,
            original_changed: true
        })
    }

    handleProfileUpdate = (formData) => {
        var payload = {
            first_name: formData.first_name.trim(),
            last_name: formData.last_name.trim(),
            email_id: formData.email_id,
            secondary_emails: formData.secondary_emails,
            ternary_email: formData.ternary_email,
            device_start_window: dayjs(formData.window_start_time).format('hh:mm A'),
            device_stop_window: dayjs(formData.window_end_time).format('hh:mm A'),
            phone:
              formData.primary_phone_number ||
              this.props.user_details.primary_phone_number,
            phone2:
              !formData.secondary_phone_number && formData.other_phone_number
                ? formData.other_phone_number
                : formData.secondary_phone_number,
            phone3:
              formData.secondary_phone_number && formData.other_phone_number
                ? formData.other_phone_number
                : '',
            date_of_birth: dayjs
              .utc(formData.date_of_birth || this.props.user_details.date_of_birth)
              .toDate(),
            gender: formData.gender,
            height: formData.height,
            weight: formData.weight,
            bmi: formData.bmi,
            organisation_name: formData.organisation_name,
            country: formData.country || this.props.user_details.country,
            specialisation_ids:
              formData.specialisation_ids ||
              this.props.user_details.specialisation_ids,
            profile_image: formData.uploaded_profile_image
              ? formData.uploaded_profile_image
              : null,
            uploaded_profile_image: formData.uploaded_profile_image
              ? formData.uploaded_profile_image
              : null,
            removed_profile_image: formData.removed_profile_image,
            rii_parameters: JSON.stringify(
              formData.riiParameters.filter(v => v !== 'ALL'),
            ),
          };

        var form_data = new FormData();
        for (var key in payload) {
            form_data.append(key, payload[key]);
        }
        this.props.update_user_info(form_data);
        //this.handleCloseUser(1);
    }

    render() {
        const {
            user_details: {
                first_name, last_name, email_id, secondary_emails, primary_phone_number, secondary_phone_number, other_phone_number, date_of_birth, country, organisation_name,
                specialisation_ids, isSecondaryUser, ternary_email, isTernaryUser,
                window_start_time, window_end_time,
            },
            user: {
                specialisation,
                countries_list
            }
        } = this.props;
        if (countries_list && countries_list.length) {
            var countries = countries_list.map(c => ({ label: c.name, value: c.name }))
        }
        if (specialisation && specialisation.length > 0) {
            var selectedArr = specialisation.filter(
                f => specialisation_ids.includes(f.id)
            );
            var selectedSpeclisationArr = selectedArr.map(item => {
                return (
                    <Chip key={item.id}
                        label={item.specialisation_name}
                        className="selected-option"
                    />
                )
            })
        }

        // Decide image src.
        let imgSrc = this.state.display_image;
        // let imgSrc = '';
        // if (this.state.tmp_uploaded_profile_image === '') {
        //     imgSrc = `${config.api_url}/${config.api_version}/get-avatar/${this.state.profile_image}`
        // } else {
        //     imgSrc = this.state.tmp_uploaded_profile_image
        // }

        const mainValues = this.state.riiParameters.filter(v => !denominators[v])
        const denominatorValues = this.state.riiParameters.filter(v => denominators[v])
        return (
            <React.Fragment>
                <NavItem className="nav-item profile-item" onClick={this.handleClickOpenUser}>
                    <NavIcon title="My Profile">
                        <Avatar className="avatar-image" src={imgSrc} alt="User" />
                    </NavIcon>
                    <NavText>
                        <span>{`${first_name} ${last_name}`}</span>
                    </NavText>
                </NavItem>
                {/* Physician Profile dialog starts */}
                <Dialog
                    className="custom-popup view-profile-popup"
                    onClose={() => this.handleCloseUser(0)}
                    aria-labelledby="customized-dialog-title-user"
                    open={this.state.openDialogUser}
                    PaperProps={{ classes: { root: 'custom-popup-root' } }}
                    disableBackdropClick={true}
                >
                    <div className="popup-wrap">
                        <div className="popup-header">
                            <DialogTitle className="popup-title"><IntlMessages id="main.myProfile"></IntlMessages></DialogTitle>
                            <div className="popup-header-right">
                                <Button className="popup-action popup-edit" disableRipple={true} disableFocusRipple={true} onClick={this.handleClickOpen} ><IntlMessages id="myprofile.edit"></IntlMessages></Button>
                                <Button onClick={() => this.handleCloseUser(0)} className="popup-close" disableRipple={true} disableFocusRipple={true}><i className="zmdi zmdi-close zmdi-hc-fw"></i></Button>
                            </div>
                        </div>
                        <DialogContent className="popup-content">
                            <div className="field-group avatar-field-group">
                                <div className="profile-avatar">
                                    <Avatar className="avatar-image" src={imgSrc} alt="User" />
                                </div>
                                <div className="field-block">
                                    <label className="field-label"><IntlMessages id="appModule.name"></IntlMessages></label>
                                    <div>{first_name}</div>
                                </div>
                                <div className="field-block">
                                    <label className="field-label"><IntlMessages id="complete.last_name"></IntlMessages></label>
                                    <div>{last_name}</div>
                                </div>
                                <div className="field-block">
                                    <label className="field-label"><IntlMessages id="main.loggedInAs"></IntlMessages></label>
                                    <div>{sessionStorage.getItem('email_id')}</div>
                                </div>
                            </div>
                            <div className="field-group">
                                <div className="view-profile-col">
                                    <div className="field-col-block">
                                        <label className="field-label"><IntlMessages id="main.primaryEmail"></IntlMessages></label>
                                        <div className="single-value">{email_id}</div>
                                    </div>
                                    <div className="field-col-block">
                                        <label className="field-label"><IntlMessages id="main.secondaryEmail"></IntlMessages></label>
                                        <div className="single-value">{secondary_emails}</div>
                                    </div>
                                    <div className="field-col-block">
                                        <label className="field-label"><IntlMessages id="main.tertiaryEmail"></IntlMessages></label>
                                        <div className="single-value">{ternary_email}</div>
                                    </div>
                                    <div className="field-col-block">
                                        <label className="field-label"><IntlMessages id="myprofile.dateOfBirth"></IntlMessages></label>
                                        <div>{dayjs(date_of_birth).format('MMMM DD, YYYY')}</div>
                                    </div>
                                    <div className="field-col-block">
                                        <label className="field-label"><IntlMessages id="myprofile.organisation"></IntlMessages></label>
                                        <div>{organisation_name}</div>
                                    </div>
                                    <div className="field-col-block">
                                        <label className="field-label"><IntlMessages id="myprofile.country"></IntlMessages></label>
                                        <div>{country}</div>
                                    </div>
                                    {/* <div className="field-col-block">
                                        <a href="# " onClick={(e) => { e.preventDefault(); this.handleClickOpen() }} className="back-link">Change Password</a>
                                    </div> */}
                                </div>
                                <div className="view-profile-col">
                                    <div className="field-col-block selected-options-wrap">
                                        <label className="field-label"><IntlMessages id="myprofile.specialization"></IntlMessages></label>
                                        <div>{selectedSpeclisationArr}</div>
                                    </div>
                                    <div className="field-col-block">
                                        <label className="field-label"><IntlMessages id="myprofile.phone"></IntlMessages></label>
                                        <div>{primary_phone_number ? primary_phone_number.includes("+") ? primary_phone_number : "+" + primary_phone_number : ""}</div>
                                        <div>{secondary_phone_number ? secondary_phone_number.includes("+") ? secondary_phone_number : "+" + secondary_phone_number : ""}</div>
                                        <div>{other_phone_number ? other_phone_number.includes("+") ? other_phone_number : "+" + other_phone_number : ""}</div>
                                    </div>
                                    <div className="field-col-block">
                                        <label className="field-label">
                                        <IntlMessages id="myprofile.deviceStartandStopWindow"></IntlMessages>
                                        </label>
                                        <div>
                                        START {window_start_time}
                                        </div>
                                        <div>
                                        STOP {window_end_time}
                                        </div>
                                    </div>
                                </div>
                                <div className="view-profile-col">
                                    <div className="field-col-block">
                                        <label className="field-label"><IntlMessages id="myprofile.customization"></IntlMessages></label>
                                        <div className="field-col-block selected-options-wrap">
                                        </div>
                                        <label className="field-label"><IntlMessages id="myprofile.customizeIndex"></IntlMessages></label>
                                        <div className="rii-labels-container" >
                                            {mainValues.map((riiParam, idx) => <div className="not-denom-label" key={JSON.stringify(riiParam) + '-' + idx} >{categoryLabels[riiParam]}</div>)}
                                            {denominatorValues.map((riiParam, idx) => <div className="denom-label" key={JSON.stringify(riiParam) + '-' + idx} >{categoryLabels[riiParam]}</div>)}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </DialogContent>
                    </div>
                </Dialog>
                {/* Physician Profile dialog ends */}

                {/* Physician Edit Profile dialog starts */}
                <Dialog
                    className="custom-popup edit-profile-popup"
                    onClose={() => this.handleCloseUser(0)}
                    aria-labelledby="customized-dialog-title"
                    open={this.state.openDialog}
                    PaperProps={{ classes: { root: 'custom-popup-root' } }}
                    disableBackdropClick={true}
                >
                    <div className="popup-wrap">
                        <div className="popup-header">
                            <DialogTitle className="popup-title"><IntlMessages id="myProfile.editProfile"></IntlMessages></DialogTitle>
                            <div className="popup-header-right">
                                <Button className="popup-close" disableRipple={true} disableFocusRipple={true} onClick={() => this.handleCloseUser(0)}><i className="zmdi zmdi-close zmdi-hc-fw"></i></Button>
                            </div>
                        </div>
                        <DialogContent className="popup-content">
                            <div className="field-group avatar-field-group">
                                <div>
                                    <div className="profile-avatar">
                                        <Avatar className="avatar-image" src={imgSrc} alt="User" />
                                    </div>
                                    <div className="links-wrap">
                                        <input
                                            style={{ display: 'none' }}
                                            className="back-link"
                                            type="file"
                                            name="avatar"
                                            onChange={(e) => { e.preventDefault(); this.fileSelectHandler(e) }}
                                            ref={fileInput => this.fileInput = fileInput}
                                        />

                                        <a href="# " className="back-link" onClick={(e) => { e.preventDefault(); this.fileInput.click() }}>Change</a>
                                        <a href="# " className="back-link remove-link" onClick={(e) => { e.preventDefault(); this.fileRemoveHandler() }}>Remove</a>

                                    </div >

                                    <div>
                                        {(
                                            this.state.profile_image_error && <span className="error-msg">{this.state.profile_image_error}</span>
                                        )}
                                    </div>
                                </div >

                                <div className="field-block">
                                    <label className="field-label"><IntlMessages id="appModule.name"></IntlMessages></label>
                                    <TextField
                                        className="custom-input"
                                        variant="outlined"
                                        type="text"
                                        value={this.state.first_name}
                                        onChange={(e) => {
                                            if (e.target.value.length <= 30) {
                                                this.setState({ first_name: e.target.value })
                                            }
                                        }}
                                        disabled={isSecondaryUser || isTernaryUser}
                                        InputProps={{
                                            classes: {
                                                disabled: 'disabled-input'
                                            }
                                        }}
                                    />
                                    {(
                                        this.state.first_name_error && <span className="error-msg">{this.state.first_name_error}</span>
                                    )}
                                </div>
                                <div className="field-block">
                                    <label className="field-label"><IntlMessages id="complete.last_name"></IntlMessages></label>
                                    <TextField
                                        className="custom-input"
                                        variant="outlined"
                                        type="text"
                                        value={this.state.last_name}
                                        onChange={(e) => {
                                            if (e.target.value.length <= 30) {
                                                this.setState({ last_name: e.target.value })
                                            }
                                        }}
                                        disabled={isSecondaryUser || isTernaryUser}
                                        InputProps={{
                                            classes: {
                                                disabled: 'disabled-input'
                                            }
                                        }}
                                    />
                                    {(
                                        this.state.last_name_error && <span className="error-msg">{this.state.last_name_error}</span>
                                    )}
                                </div>
                            </div >
                            {(
                                this.state.update_error && <span className="error-msg">{this.state.update_error}</span>
                            )
                            }
                            <div className="field-group edit-profile-group">
                                <div className="edit-profile-col">
                                    <div className="field-col-block">
                                        <label className="field-label"><IntlMessages id="main.primaryEmail"></IntlMessages></label>
                                        <TextField
                                            className="custom-input"
                                            variant="outlined"
                                            disabled
                                            type="email"
                                            placeholder="Email"
                                            value={this.state.email_id}
                                            onChange={(e) => { this.setState({ email_id: e.target.value }) }}
                                            InputProps={{
                                                classes: {
                                                    disabled: 'disabled-input'
                                                }
                                            }}
                                        />
                                        {(
                                            this.state.email_error && <span className="error-msg">{this.state.email_error}</span>
                                        )}
                                    </div>

                                    <div className="field-col-block">
                                        <label className="field-label"><IntlMessages id="main.secondaryEmail"></IntlMessages></label>
                                        <TextField
                                            className="custom-input"
                                            variant="outlined"
                                            type="email"
                                            disabled={isTernaryUser}
                                            placeholder="Email"
                                            value={this.state.secondary_emails}
                                            InputProps={{
                                                classes: {
                                                    disabled: 'disabled-input'
                                                }
                                            }}
                                            onChange={(e) => { this.setState({ secondary_emails: e.target.value }) }}
                                        />
                                        {(
                                            this.state.secondary_email_error && <span className="error-msg">{this.state.secondary_email_error}</span>
                                        )}
                                    </div>
                                    {/* ternary email */}
                                    <div className="field-col-block">
                                        <label className="field-label"><IntlMessages id="main.tertiaryEmail"></IntlMessages></label>
                                        <TextField
                                            className="custom-input"
                                            variant="outlined"
                                            type="email"
                                            placeholder="Email"
                                            disabled={isSecondaryUser}
                                            value={this.state.ternary_email}
                                            onChange={(e) => { this.setState({ ternary_email: e.target.value }) }}
                                            InputProps={{
                                                classes: {
                                                    disabled: 'disabled-input'
                                                }
                                            }}
                                        />
                                        {(
                                            this.state.ternary_email_error && <span className="error-msg">{this.state.ternary_email_error}</span>
                                        )}
                                    </div>
                                    <div>
                                        <label className="field-label">
                                            <IntlMessages id="myprofile.startTime"></IntlMessages>
                                        </label>
                                        <div>
                                            {window_start_time ? window_start_time: 'N/A'}
                                        </div>
                                        <div className="field-block">
                                        <label className="field-label">
                                            <IntlMessages id="newpatient.stopTime"></IntlMessages>
                                        </label>
                                        <div>
                                            {window_end_time ? window_end_time : 'N/A'}
                                        </div>
                                        </div>

                                        <div className="field-col-block">
                                            <label className="window_time_change pt-1 field-label">
                                            <IntlMessages id="editpatient.changeWinTime"></IntlMessages>
                                            </label>
                                        </div>
                                    </div>
                                    {/* <div className="field-col-block">
                                        <label className="field-label">
                                        <IntlMessages id="myprofile.startTime"></IntlMessages>
                                        </label>
                                        <div className="grey-calendar-wrapper">
                                        <TimePicker
                                            disabled
                                            showSecond={false}
                                            onChange={time => {
                                                this.setState({ window_start_time: time });
                                            }}
                                            value={dayjs(this.state.window_start_time)}
                                            // onChange={time => {
                                            //     setPayload({
                                            //         ...payload,
                                            //         window_start_time: time && time.format("HH:mm:ss"),
                                            //     })
                                            // }}
                                            // value={payload.window_start_time ? dayjs(payload.window_start_time,'HH:mm:ss') : 
                                            // deviceWindowStartStopTime.window_start_time ?
                                            // dayjs(deviceWindowStartStopTime.window_start_time,'HH:mm:ss') :
                                            // dayjs('11:00:00','HH:mm:ss')}
                                        />
                                        </div>
                                    </div>
                                    <div className="field-col-block">
                                        <label className="field-label">
                                        <IntlMessages id="myprofile.stopTime"></IntlMessages>
                                        </label>
                                        <div className="grey-calendar-wrapper">
                                            <TimePicker
                                                disabled
                                                popupStyle={{ zIndex: 1500 }}
                                                open={this.state.openStopWindow}
                                                onOpenChange={open => this.setState({ openStopWindow: open })}
                                                onChange={time => {
                                                    this.setState({ window_end_time: time });
                                                }}
                                                value={dayjs(this.state.window_end_time)}
                                            />
                                        </div>
                                    </div> */}
                                </div >
                                <div className="edit-profile-col">
                                    <div className="field-col-block">
                                        {(!isSecondaryUser && !isTernaryUser) &&
                                            <>
                                                <div className="selected-options-wrap">
                                                    {this.state.specialisationInput.length > 0 && this.state.specialisationInput.map(chip =>
                                                        <Chip key={"specialisation_" + chip.id}
                                                            icon={chip.selected ? <img className="chip-check-icon" alt="icon" src={checkIcon} /> : null}
                                                            label={chip.specialisation_name}
                                                            className={chip.selected ? "selected-option selected" : "selected-option"}
                                                            onClick={() => {
                                                                let selection = this.state.specialisationInput;
                                                                let selectedChips = "";
                                                                selection.forEach((c) => {
                                                                    if (c.id === chip.id) {
                                                                        c.selected = !chip.selected;

                                                                    }
                                                                    if (c.selected) {
                                                                        selectedChips += c.id + ","
                                                                    }
                                                                })
                                                                this.setState({ specialisationInput: selection });
                                                                this.setState({ specialisation_ids: selectedChips });
                                                            }}
                                                        />)
                                                    }
                                                </div>
                                            </>}
                                    </div>
                                    <div className="field-col-block">
                                        <label className="field-label"><IntlMessages id="appModule.phone"></IntlMessages></label>
                                        <div className="phone-field">
                                            <TextField
                                                className="custom-input action-input"
                                                variant="outlined"
                                                placeholder="Primary Phone Number"
                                                value={this.state.primary_phone_number}
                                                onChange={(e) => { if (e.target.value.length <= 25) this.setState({ primary_phone_number: e.target.value }) }}
                                                InputProps={{
                                                    endAdornment: (
                                                        <InputAdornment position="end">
                                                            {primary_phone_number && <IconButton disabled={isSecondaryUser || isTernaryUser} className="clear-icon" aria-label="Toggle phone visibility"
                                                                onClick={() => {
                                                                    this.setState({
                                                                        primary_phone_number: ""
                                                                    })
                                                                }}
                                                            >
                                                                <Close />
                                                            </IconButton>}

                                                        </InputAdornment>
                                                    ),
                                                    classes: {
                                                        disabled: 'disabled-input'
                                                    }
                                                }}
                                                disabled={isSecondaryUser || isTernaryUser}

                                            />
                                            {(
                                                this.state.primary_phone_number_error && <span className="error-msg">{this.state.primary_phone_number_error}</span>
                                            )}
                                            {secondary_phone_number || other_phone_number || this.state.showPhoneFlag !== 0 ? null :
                                                (
                                                    <a href="# " className="back-link" onClick={(e) => {
                                                        e.preventDefault();
                                                        this.setState({
                                                            showPhoneFlag: 1
                                                        })
                                                    }}>Add</a>)}
                                        </div>
                                        {(secondary_phone_number || this.state.showPhoneFlag !== 0) &&
                                            <div className="phone-field">
                                                <TextField
                                                    variant="outlined"
                                                    className="custom-input action-input"
                                                    placeholder="Secondary Phone Number"
                                                    disabled={isSecondaryUser || isTernaryUser}
                                                    value={this.state.secondary_phone_number}
                                                    onChange={(e) => { if (e.target.value.length <= 25) this.setState({ secondary_phone_number: e.target.value }) }}
                                                    InputProps={{
                                                        endAdornment: (
                                                            <InputAdornment position="end">
                                                                {this.state.secondary_phone_number && <IconButton className="clear-icon" aria-label="Toggle phone visibility"
                                                                    onClick={() => {
                                                                        this.setState({
                                                                            secondary_phone_number: ""
                                                                        })
                                                                    }}
                                                                >
                                                                    <Close />
                                                                </IconButton>}

                                                            </InputAdornment>
                                                        ),
                                                        classes: {
                                                            disabled: 'disabled-input'
                                                        }
                                                    }}


                                                />
                                                {(
                                                    this.state.secondary_phone_number_error && <span className="error-msg">{this.state.secondary_phone_number_error}</span>
                                                )}
                                                {(!other_phone_number && this.state.showPhoneFlag !== 2) ? <a href="# " className="back-link" onClick={(e) => {
                                                    e.preventDefault();
                                                    this.setState({
                                                        showPhoneFlag: 2
                                                    })
                                                }}>Add</a> : null}
                                            </div>
                                        }

                                        {(other_phone_number || this.state.showPhoneFlag === 2) &&
                                            <div className="phone-field">
                                                <TextField
                                                    variant="outlined"
                                                    placeholder="Additional Phone Number"
                                                    className="custom-input action-input"
                                                    value={this.state.other_phone_number}
                                                    onChange={(e) => { if (e.target.value.length <= 25) this.setState({ other_phone_number: e.target.value }) }}
                                                    InputProps={{
                                                        endAdornment: (
                                                            <InputAdornment position="end">
                                                                {this.state.other_phone_number && <IconButton className="clear-icon" aria-label="Toggle phone visibility"
                                                                    onClick={() => {
                                                                        this.setState({
                                                                            other_phone_number: ""
                                                                        })
                                                                    }}
                                                                >
                                                                    <Close />
                                                                </IconButton>}

                                                            </InputAdornment>
                                                        ),
                                                        classes: {
                                                            disabled: 'disabled-input'
                                                        }
                                                    }}
                                                    disabled={isSecondaryUser || isTernaryUser}

                                                />
                                                {(
                                                    this.state.other_phone_number_error && <span className="error-msg">{this.state.other_phone_number_error}</span>
                                                )}
                                            </div>
                                        }

                                    </div>
                                    <div className="field-col-block">
                                        <label className="field-label"><IntlMessages id="editProfile.selectRII"></IntlMessages></label>
                                        <div className="phone-field">
                                            <TreeSelect
                                                treeData={treeData}
                                                getPopupContainer={node => node.parentNode}
                                                value={this.state.riiParameters}
                                                onChange={this.onRiiParametersChange}
                                                treeCheckable={true}
                                                showCheckedStrategy={TreeSelect.SHOW_ALL}
                                                placeholder={'Please select'}
                                                style={{
                                                    width: '100%',
                                                }}
                                                disabled={isSecondaryUser || isTernaryUser}

                                            />
                                        </div>
                                    </div >
                                    <div className="field-col-block">
                                        <label className="field-label"><IntlMessages id="myprofile.dateOfBirth"></IntlMessages></label>
                                        <div className="grey-calendar-wrapper">
                                            <DatePicker
                                                ref={dob_ref}
                                                maxDate={dayjs.utc().toDate()}
                                                selected={this.state.date_of_birth || dayjs.utc(this.props.user_details.date_of_birth).toDate()}
                                                dateFormat="MMMM dd, yyyy"
                                                disabled={isSecondaryUser || isTernaryUser}
                                                calendarClassName="custom-calendar grey-calendar"
                                                onChange={(date) => {
                                                    this.setState({ date_of_birth: date });
                                                }}

                                                customInput={<CustomDateInput />}
                                                renderCustomHeader={({
                                                    date,
                                                    decreaseMonth,
                                                    changeYear,
                                                    increaseMonth,
                                                    prevMonthButtonDisabled,
                                                    nextMonthButtonDisabled
                                                }) => (
                                                    <>
                                                        <div className="calendar-controls">
                                                            <div className="left-controls d-flex">
                                                                <span className="month-label">{dayjs(date).format('MMMM')} </span>
                                                                <Select
                                                                    isSearchable={false}
                                                                    options={years}

                                                                    className="custom-react-select datepicker-react-select"
                                                                    classNamePrefix="custom-react-select"
                                                                    defaultValue={{ label: dayjs(date).year(), value: dayjs(date).year() }}
                                                                    value={{ label: dayjs(date).year(), value: dayjs(date).year() }}
                                                                    onChange={c => changeYear(c.value)}
                                                                />

                                                            </div>
                                                            <div className="right-controls">
                                                                <span className="zmdi zmdi-chevron-left zmdi-hc-fw" onClick={decreaseMonth} disabled={prevMonthButtonDisabled}></span>
                                                                <span className="zmdi zmdi-chevron-right zmdi-hc-fw" onClick={increaseMonth} disabled={nextMonthButtonDisabled}></span>
                                                            </div>
                                                        </div>
                                                    </>
                                                )}
                                            />
                                        </div>
                                    </div>
                                    <div className="field-col-block">
                                        <label className="field-label"><IntlMessages id="myprofile.organisation"></IntlMessages></label>
                                        <TextField
                                            className="custom-input"
                                            variant="outlined"
                                            disabled={isSecondaryUser || isTernaryUser}
                                            type="text"
                                            InputProps={{
                                                classes: {
                                                    disabled: 'disabled-input'
                                                }
                                            }}
                                            value={this.state.organisation_name}
                                            onChange={(e) => {
                                                if (e.target.value.length <= 80) {
                                                    this.setState({ organisation_name: e.target.value })
                                                }
                                            }}
                                        />
                                    </div>
                                    <div className="field-col-block">
                                        <label className="field-label"><IntlMessages id="myprofile.country"></IntlMessages></label>
                                        <Select
                                            className="custom-react-select custom-select-box"
                                            classNamePrefix="custom-react-select"
                                            defaultValue={{ label: this.state.country, value: this.state.country }}
                                            isDisabled={isSecondaryUser || isTernaryUser}
                                            isLoading={false}
                                            isClearable={false}
                                            isRtl={false}
                                            isSearchable={true}
                                            noOptionsMessage={() => "Country not found"}
                                            options={countries}
                                            menuPlacement="top"

                                            onChange={option => this.setState({ country: option.value })}
                                        />
                                    </div>
                                </div >
                            </div >

                        </DialogContent>
                        <DialogActions className="popup-footer">
                            <Button onClick={() => this.handleCloseUser(0)} disableRipple={true} className="secondary-button">
                                <IntlMessages id="main.cancel"></IntlMessages>
                            </Button>
                            <Button onClick={this.validateInputs} disableRipple={true} className="primary-button">
                                <IntlMessages id="editProfile.saveChanges"></IntlMessages>
                            </Button>
                        </DialogActions>
                    </div >
                </Dialog >
                {/* Physician Edit Profile dialog ends */}
            </React.Fragment >
        );
    }
}
const mapStateToProps = (state) => {
    return {
        ...state.user,
        user: state.user,
        locale: state.settings,
        specialisation: state.specialisation,
        countries_list: state.countries_list
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        get_list_of_specialisation: () => dispatch(get_list_of_specialisation_action()),
        fetch_user_countries: () => dispatch(fetch_user_countries_action()),
        reset_user_update: () => dispatch(reset_user_update_details()),
        update_user_info: (payload) => dispatch(update_user_info_action(payload))
    }
};
export default connect(mapStateToProps, mapDispatchToProps)(UserInfo);
